var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { useTheme } from "../styling";
const StyledSvg = styled.svg `
  width: 1em;
`;
export const SpinnerIcon = (_a) => {
    var { style, color, size } = _a, props = __rest(_a, ["style", "color", "size"]);
    const theme = useTheme();
    return (React.createElement(StyledSvg, Object.assign({ xmlns: "http://www.w3.org/2000/svg" }, props, { viewBox: "0 0 38 38", style: Object.assign({ width: size, height: size }, style), stroke: theme.name === "noldus" ? "#0E8D8A" : color || theme.colors.foreground }),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("g", { transform: "translate(1 1)", strokeWidth: "2" },
                React.createElement("circle", { strokeOpacity: ".5", cx: "18", cy: "18", r: "18" }),
                React.createElement("path", { d: "M36 18c0-9.94-8.06-18-18-18", transform: "rotate(183.844 18 18)" },
                    React.createElement("animateTransform", { attributeName: "transform", type: "rotate", from: "0 18 18", to: "360 18 18", dur: "1s", repeatCount: "indefinite" }))))));
};
//# sourceMappingURL=SpinnerIcon.js.map